import { CIEnvironmentConfiguration } from '../environment-config';

export const environment: CIEnvironmentConfiguration = {
  production: false,
  organizationUUID: '45b42b5d-9bda-4e01-b157-5a3baeae7ff9',
  authenticationUrl: 'https://api.dev.datalean.it/auth',
  mediaLibraryUrl: 'https://api.dev.datalean.it/media-library/v2/',
  featureValueUrl: 'https://api.dev.datalean.it/feature/featureValue/v2/',
  thumbnailConfigUrl: 'https://api.dev.datalean.it/media-library/thumbnail-config/v2/',
  configUrl: 'https://api.dev.datalean.it/configuration/config/',
  userUrl: 'https://api.dev.datalean.it/user/application/v2/',
  // practiceUrl: 'http://localhost:3040/practice/',
  // practiceSectionContainerUrl: "http://localhost:3040/practice-section-container/",
  // practiceTemplateUrl: 'http://localhost:3040/practice-template',
  // patientUrl: 'http://localhost:3040/patient/',
  practiceUrl: 'https://api.dev.datalean.it/consenso-informato/practice/',
  practiceSectionContainerUrl: 'https://api.dev.datalean.it/consenso-informato/practice-section-container/',
  practiceTemplateUrl: 'https://api.dev.datalean.it/consenso-informato/practice-template/',
  patientUrl: 'https://api.dev.datalean.it/consenso-informato/patient/',
  practiceSectionUrl: 'https://api.dev.datalean.it/consenso-informato/practice-section/',
  pageSize: 15,
  availableLocales: ['it-IT'],
  defaultLocale: 'it-IT',
  registration: {
    enabled: false,
    url: (typeof window !== 'undefined' ? window?.location.origin : '') + '/registration',
  },
  dataleanAppConfigKeys: {
    practiceFooterText: 'practiceFooterText',
  },
};
